export default "__VITE_ASSET__DgbMPzYH__"